
<div class="flex flex-column h-full" *ngIf="!openedChat">
    <div class="flex align-items-center " style="justify-content: center;">
        <div class="relative flex align-items-center mr-3">
            <img src="assets/logotipo.png" alt="user.name" class="w-4rem h-4rem border-circle shadow-4" style="width: 5vw;">
        </div>
        <div class="mr-2">
            <span class="text-900 font-semibold block" style="font-size: 3em;">Lumy</span>
        </div>
    </div>
    <div style="justify-content: center;"  class="flex">
        <span class="text-900 font-semibold block" style="font-size: 1.5em;margin-top: 1em;">
            <i>
                Como posso te ajudar Hoje?
            </i>
        </span>
        
    </div>

    <div [ngClass]="{'tema-claro': tema === 'light', 'tema-escuro': tema !== 'light'}"
    class="p-3 md:px-4 lg:px-6 lg:py-4 flex"
    style=" margin-top: 0; justify-content: center;align-items: center;"
    #chatWindow
    
     >
    
       
       <div class="flex" style="width: 90%; height: 10vh;flex-direction: column;margin-top: 2vh; ">
        
            <p-messages 
            [value]="[{ severity: 'info', detail: 'É recomendado o uso da Verificar Documentação apenas em documentos oficiais do processo ' }]" 
            [enableService]="false" 
            [closable]="false" />
            <div class="flex" style="flex-direction: row;justify-content: space-between;width: 100%;margin-bottom: 5vh;">
                <p-button [style]="{width:'60vh'}" [outlined]="true" severity="help" (onClick)="OpenAi(3)">
                <span>
                    <i class="pi pi-sparkles" ></i>&nbsp; Verificar documentação e habilitações necessárias para participar da licitação
                </span>
                </p-button>
            </div>
            <div class="flex" style="flex-direction: row;"> 
                <p-button   [outlined]="true" [style]="{width:'60vh'}"   severity="help" (onClick)="OpenAi(2)">
                    <span>
                        <i class="pi pi-sparkles" ></i>&nbsp; Tirar dúvida sobre conteúdo do documento selecionado
                    </span>
                </p-button>
                
            </div>
       </div> 
    </div>
</div>

<div  *ngIf="openedChat">
    <app-chat-ai-open *ngIf="openedChat" [myUser]="myUser" [modeSelected]="chatMode" [infoPath] = "infoPath" [style]="{overflow:'hidden'}"></app-chat-ai-open>
</div>